enum InvoiceStatus {
	Pending = 10,
    Draft = 20,
	Submitted = 30,
    Authorised = 90,
    Paid = 95,
    Voided = 99,
    Deleted = 100

}

export default InvoiceStatus;